"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _uiKit = require("@icis/ui-kit");
var _NewForUser = require("./NewForUser.style");
const NewForUser = () => /*#__PURE__*/_react.default.createElement(_NewForUser.NewForUserContainer, null, /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none"
}, /*#__PURE__*/_react.default.createElement("circle", {
  cx: "6",
  cy: "6",
  r: "5",
  fill: "url(#paint0_linear_8777_180914)",
  stroke: _uiKit.theme.colours.PRIMARY_1,
  strokeWidth: "2"
}), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
  id: "paint0_linear_8777_180914",
  x1: "12",
  y1: "6.02097",
  x2: "-6.83705e-08",
  y2: "6.02096",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/_react.default.createElement("stop", {
  stopColor: "#00DE96"
}), /*#__PURE__*/_react.default.createElement("stop", {
  offset: "1",
  stopColor: "#008FF7"
})))));
var _default = exports.default = NewForUser;